import { useRoutes } from 'react-router-dom';
import { lazy } from 'react';

import Loadable from 'components/loading/Loadable';
import dispatcher from './routesDispatcher';
import { routesReporting as reporting } from './routesReporting';
import eai from './routesEai';
import { AppModule, Routes } from 'utils/constants';
import MainLayout from 'components/layout/MainLayout/MainLayout';
import HomePage from 'views/pages/HomePage';
import { routesSystem as system } from 'routes/routesSystem';

const PageNotFound = Loadable(
  lazy(() => import('views/pages/maintenance/PageNotFound/PageNotFound'))
);

// ==============================|| ROUTES ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: `${Routes.BASE_PATH}:tenant`,
      element: <MainLayout module={AppModule.HOMEPAGE} />,
      children: [
        {
          path: `${Routes.BASE_PATH}:tenant`,
          element: <HomePage />
        }
      ]
    },
    dispatcher,
    eai,
    reporting,
    system,
    { path: '*', element: <PageNotFound /> }
  ]);
}
export { replaceDynamicPathParams } from 'routes/routeUtils';
